// Components
import Table from "../../../components/Table/Table";

// Helpers
import {utils} from "../../../helpers";
import { useResult } from "../../../shared/formContext/hooks/useResult";
import {useEffect, useState} from "react";
import {__} from "@wordpress/i18n";

const TableView = () => {
    const { resultData } = useResult();
    const { response } = resultData;
    const [ interestRate, setInterestRate ] = useState({});
    const [ total, setTotal ] = useState({});

    useEffect(() => {
        if (response) {
            const {interest_rate, total} = response?.data?.result;
            setInterestRate(interest_rate);
            setTotal(total);
        }
    }, [response]);

    return (Object.keys(total).length !== 0 && Object.keys(interestRate).length !== 0 && <Table
        noMobile
        headers={[
            {
                value: __('Crédito Atual', 'df-simulators'),
                span: 2,
                className: 'align-right',
            },
            {
                value: __('Novo Crédito', 'df-simulators'),
            },
        ]}
        data={[
            [
                {value: __('Capital em dívida', 'df-simulators')},
                {value: utils.toEuro(total.old_debit, 2)},
                {value: utils.toEuro(total.new_debit, 2)},
            ],
            [
                {value: __('Juros', 'df-simulators')},
                {value: utils.toEuro(interestRate.old_amount, 2)},
                {value: utils.toEuro(interestRate.new_amount, 2)},
            ],
            [
                {value: __('Total', 'df-simulators'), className: 'font-bold'},
                {
                    value: utils.toEuro(total.old_amount),
                    className: 'font-bold',
                },
                {
                    value: utils.toEuro(total.new_amount),
                    className: 'font-bold',
                },
            ],
        ]}
    />);
};

export default TableView;
